<template>
  <p>
    {{ $t('redemption-history-reference-id-label') }}
    <span class="font-weight-bold">{{ referenceId }}</span>
    {{ $t('redemption-history-reference-id-helper') }}
  </p>
</template>
<script>
export default {
  name: 'OrderReferenceDetail',
  props: {
    referenceId: {
      type: String,
      required: true
    }
  }
}
</script>
